import { Controller } from '@hotwired/stimulus'
import { congestionIcon } from '../helpers/congestion_icon'
import 'tui-calendar/dist/tui-calendar.css'
import Calendar from 'tui-calendar'
import holidayJp from '@holiday-jp/holiday_jp'
import '../stylesheets/calendar.css'

export default class extends Controller {
  static values = {
    schedules: Array
  }

  calendar = new Calendar(document.getElementById('calendar'), {
    id: '1',
    name: 'My Calendar',
    defaultView: 'month',
    isReadOnly: true,
    scheduleView: 'allday',
    useCreationPopup: false,
    useDetailPopup: true,
    template: {
      popupDetailBody: function (schedule) {
        return `<span class="flex items-center">${icon(schedule.body)} ${message(schedule.body)}</span>`
      },
      allday: function (schedule) {
        return `<span class="flex items-center">${icon(schedule.raw.level)} ${schedule.title}</span>`
      },
      monthGridHeader: function (dayModel) {
        const month = parseInt(dayModel.date.split('-')[1], 10)
        const date = parseInt(dayModel.date.split('-')[2], 10)
        let classNames = ['tui-full-calendar-weekday-grid-date']

        // 土曜日の日付を青色
        if (dayModel.day === 6) {
          classNames.push('text-blue-500')
        }

        // 祝日の日付を赤色
        if (holidayJp.isHoliday(new Date(dayModel.date))) {
          classNames = classNames.filter(name => name !== 'text-blue-500')
          classNames.push('text-red-500')
        }

        if (dayModel.isToday) {
          classNames.push('tui-full-calendar-weekday-grid-date-decorator')
          return month + '/' + '<span id="today-circle" class="' + classNames.join(' ') + '">' + date + '</span>'
        }

        return '<span class="' + classNames.join(' ') + '">' + month + '/' + date + '</span>'
      }
    },
    month: {
      daynames: ['日', '月', '火', '水', '木', '金', '土'],
      startDayOfWeek: 0,
      narrowWeekend: false,
      visibleWeeksCount: 5,
      visibleScheduleCount: 6
    }
  })

  connect () {
    this.getCalendarData()
  }

  getCalendarData () {
    this.schedulesValue.forEach((schedule, index) => {
      this.calendar.createSchedules([
        {
          id: index,
          calendarId: schedule.raw.categoryId,
          title: schedule.title,
          category: 'allday',
          start: schedule.start,
          borderColor: schedule.borderColor,
          bgColor: schedule.bgColor,
          raw: schedule.raw,
          body: schedule.raw.level
        }
      ])
    })
  }

  filter (event) {
    if (Number(event.currentTarget.value) === 0) {
      this.schedulesValue.forEach(schedule => {
        this.calendar.toggleSchedules(schedule.raw.categoryId, false)
      })
      this.calendar.setTheme({
        'month.schedule.height': '24px'
      })
    } else {
      this.schedulesValue.forEach(schedule => {
        this.calendar.toggleSchedules(schedule.raw.categoryId, false)
      })
      this.schedulesValue.filter(schedule => schedule.raw.categoryId !== Number(event.currentTarget.value)).forEach(schedule => {
        this.calendar.toggleSchedules(schedule.raw.categoryId, true)
      })
      this.calendar.setTheme({
        'month.schedule.height': '50px'
      })
    }
  }
}

function icon (level) {
  if (level === 'vacant') {
    return congestionIcon.vacant
  } else if (level === 'busy') {
    return congestionIcon.busy
  } else if (level === 'full') {
    return congestionIcon.full
  } else {
    return congestionIcon.free
  }
}

function message (level) {
  if (level === 'vacant') {
    return '<span>調整待ち　03件以内</span>'
  } else if (level === 'busy') {
    return '<span>調整待ち　10件以上</span>'
  } else if (level === 'full') {
    return '<span>80%以上が決定、調整待ちもある状況</span>'
  } else {
    return '<span>調整待ち　04件~09件</span>'
  }
}
